/* ORBIT infinite scroll — 2026-09-24. Appends next paginate page of tiles into [data-orbit-grid]. */
(function () {
  function tileKey(el) {
    var h = el.getAttribute('href') || '';
    return h.split('?')[0].split('#')[0];
  }

  function withSection(url, sectionId) {
    if (!sectionId) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId);
  }

  function init(root) {
    if (!root || root.dataset.orbitInfiniteReady) return;
    var grid = root.querySelector('[data-orbit-grid]');
    var more = root.querySelector('[data-orbit-more]');
    var link = more ? more.querySelector('[data-orbit-next]') : null;
    if (!grid || !more || !link) return;
    root.dataset.orbitInfiniteReady = '1';

    var sectionId = root.getAttribute('data-section-id') || '';
    var nextUrl = link.getAttribute('href');
    var loading = false;
    var done = false;
    var fails = 0;
    var seen = {};
    grid.querySelectorAll('[data-orbit-tile]').forEach(function (t) { seen[tileKey(t)] = true; });

    function finish() {
      done = true;
      if (io) io.disconnect();
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (more && more.parentNode) more.parentNode.removeChild(more);
    }

    function parse(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var g = doc.querySelector('[data-orbit-grid]');
      if (!g) return null;
      var n = doc.querySelector('[data-orbit-next]');
      return { tiles: Array.prototype.slice.call(g.querySelectorAll('[data-orbit-tile]')), next: n ? n.getAttribute('href') : null };
    }

    function load() {
      if (loading || done || !nextUrl) return;
      loading = true;
      more.classList.add('is-loading');
      var url = nextUrl;
      fetch(withSection(url, sectionId), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          var res = parse(html);
          if (!res && sectionId) {
            return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(parse);
          }
          return res;
        })
        .then(function (res) {
          if (!res) throw new Error('no grid');
          fails = 0;
          var added = 0;
          var frag = document.createDocumentFragment();
          res.tiles.forEach(function (t) {
            var k = tileKey(t);
            if (!k || seen[k]) return;
            seen[k] = true;
            frag.appendChild(document.importNode(t, true));
            added += 1;
          });
          grid.appendChild(frag);
          if (added) {
            root.dispatchEvent(new CustomEvent('orbit:tiles-appended', { bubbles: true, detail: { added: added } }));
          }
          if (res.next && res.next !== url) {
            nextUrl = res.next;
            link.setAttribute('href', nextUrl);
          } else {
            finish();
          }
        })
        .catch(function () {
          fails += 1;
          if (fails >= 3) { done = true; if (io) io.disconnect(); }
        })
        .then(function () {
          loading = false;
          if (more) more.classList.remove('is-loading');
          if (!done) setTimeout(check, 50);
        });
    }

    function check() {
      if (done || loading) return;
      var r = more.getBoundingClientRect();
      if (r.top < (window.innerHeight || document.documentElement.clientHeight) + 1200) load();
    }

    link.addEventListener('click', function (e) {
      e.preventDefault();
      load();
    });

    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) load(); });
      }, { rootMargin: '1200px 0px 1200px 0px' });
      io.observe(more);
    }
    /* Fast flings can jump past the sentinel (tall footer) — also check on scroll, rAF-throttled */
    var ticking = false;
    function onScroll() {
      if (done || ticking) return;
      ticking = true;
      (window.requestAnimationFrame || setTimeout)(function () { ticking = false; check(); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    check();
  }

  function boot() {
    document.querySelectorAll('[data-orbit-infinite]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
